export const SITE_NAME = "JC Law Foundation";
export const TAGLINE = "Every Second Matters";

export const PETITION_URL = "https://www.change.org/p/pass-jc-law-require-aeds-cpr-training-in-hotels?recruiter=1411795511&recruited_by_id=team-contact-info&utm_source=share_petition&utm_campaign=petition_dashboard&utm_medium=copylink&share_id=jWy5s5cywc";

export const PETITION_GOAL = 10000;
// Fallback signature count if BOTH the live backend endpoint AND the
// public CORS proxy fallbacks fail. The live count comes from Change.org
// via /api/petition-count on both preview (FastAPI) and production
// (Netlify Function), so this is only shown as a last resort.
export const PETITION_FALLBACK_COUNT = 101;

export const CONTACT = {
    general: "Information@jclawsc.org",
    press: "Press@jclawsc.org",
    partnership: "partnership@jclawsc.org",
    phone: "(843) 284-6979",
    phoneRaw: "+18432846979",
    location: "PO Box 3, Little River, SC 29566",
};

export const SOCIAL = {
    instagram: "https://www.instagram.com/jclawfoundation/?utm_source=ig_web_button_share_sheet",
    tiktok: "https://www.tiktok.com/@jclaw.foundation?is_from_webapp=1&sender_device=pc",
    facebook: "https://www.facebook.com/profile.php?id=61590534174757",
    linkedin: "https://www.linkedin.com/company/jclaw-foundation",
    twitter: "https://x.com/JCLawFoundation",
    givebutter: "https://givebutter.com/turning-loss-into-change-2rfwrb",
};

export const BOARD_MEMBERS = [
    {
        name: "Princess Bradley",
        title: "Vice President",
        email: "P.bradley@jclawsc.org",
        phone: "(843) 284-6374",
        phoneRaw: "+18432846374",
        image: "/images/princess-bradley.png",
    },
    {
        name: "Emily Brock",
        title: "Treasurer",
        email: "E.brock@jclawsc.org",
        phone: "(843) 284-7169",
        phoneRaw: "+18432847169",
        image: "/images/emily-brock.png",
    },
];

export const NAV_LINKS = [
    { label: "Our Story", path: "/our-story" },
    { label: "Founder", path: "/founder" },
    { label: "The Legislation", path: "/legislation" },
    { label: "Get Involved", path: "/get-involved" },
    { label: "Resources", path: "/resources" },
    { label: "FAQ", path: "/faq" },
    { label: "Contact", path: "/contact" },
];

export const STATS = [
    { value: 350000, suffix: "+", label: "Out-of-hospital cardiac arrests every year", source: "American Heart Association" },
    { value: 10, suffix: "%", label: "Survival rate drops every minute without CPR", source: "American Heart Association" },
    { value: 3, prefix: "2–", suffix: "×", label: "Greater survival when an AED is used", source: "American Heart Association" },
    { value: 20000, suffix: "+", label: "Hotels lack adequate AEDs & protocols", source: "Public Safety Reports" },
];
